__turbopack_context__.v({
  "channelGrid": "PopularChannelsModal-module-scss-module__rnSeiW__channelGrid",
  "channelItem": "PopularChannelsModal-module-scss-module__rnSeiW__channelItem",
  "tabDescription": "PopularChannelsModal-module-scss-module__rnSeiW__tabDescription",
});
